import { render, staticRenderFns } from "./AddQualificationAction.vue?vue&type=template&id=554bd9ce&"
import script from "./AddQualificationAction.vue?vue&type=script&lang=js&"
export * from "./AddQualificationAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports